<template>
  <div>
    <v-checkbox
      v-model="modifyData[modifyIndex].isHalf"
      label="Is this person a half sibling?"></v-checkbox>
    <v-select
      v-if="modifyData[modifyIndex].isHalf === true"
      dense
      outlined
      :items="questions"
      label="What kind of half sibling?"
      v-model="modifyData[modifyIndex].halfSib"></v-select>
  </div>
</template>

<script>
  import { mapFields } from "vuex-map-fields";
  export default {
    props: {
      modifyData: Array,
      modifyIndex: Number
    },
    mounted () {
    },
    methods: {
    },
    data: () => ({
      questions: [
        'maternal half sibling (shares the same mother)',
        'paternal half sibling (shares the same father)'
      ]
    }),
    computed: {
      ...mapFields("patientQuestion", [
        "dataModel",
        "genderList",
        "newGenderList",
      ])
    }
  };
</script>
<style>
.condCard {
  padding: 20px;
  margin: 5px;
}
.padded {
  margin: 5px 5px 5px 5px;
}
</style>
